export const clearStorageExcept = (exceptions) => {
  exceptions = exceptions || []
  var deleteKeys = []
  for (var i = 0; i < sessionStorage.length; i++) {
    if (!_.contains(exceptions, i)) {
      deleteKeys.push(sessionStorage.key(i))
    }
  }
  _.each(deleteKeys, (key) => {
    sessionStorage.removeItem(key)
  })
}

export const clearStorage = () => {
  sessionStorage.clear()
}
